import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupContract } from "src/components/Shared/NewForms/NFLookupContract";
import { NFLookupCustomer } from "src/components/Shared/NewForms/NFLookupCustomer";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";
import { NFLookupSalesOrders } from "src/components/Shared/NewForms/NFLookupSalesOrders";
import { NFLookupWarehouse } from "src/components/Shared/NewForms/NFLookupWarehouse";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";

export const CustomerInvoicesDetailMain = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Document#")} fieldName={"documentNumber"} disabled />
        </Col>
        <Col sm={3}>
          <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} />
        </Col>
        <Col sm={3}>
          <NFDateInput title={t("ApprovalDate")} fieldName={"approvalDate"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany fieldName={"companyId"} title={t("Company")} />
        </Col>
        <Col sm={6}>
          <NFLookupDivision fieldName={"divisionId"} title={t("Division")} companyId={watch("companyId")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupWarehouse fieldName={"warehouseId"} title={t("Warehouse")} companyId={watch("companyId")} />
        </Col>
        <Col sm={6}>
          <NFLookupCustomer fieldName={"customerId"} title={t("Customer")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupContract fieldName={"contractId"} title={t("Contract")} />
        </Col>
        <Col sm={6}>
          <NFLookupCurrency title={t("Currency")} fieldName={"currencyId"} required={true} />
        </Col>
        <Col sm={6}>
          <NFLookupSalesOrders title={t("BaseDocument")} fieldName="baseDocumentId" />
        </Col>
      </Row>
    </>
  );
};
